<template>
  <section class="section">
    <div class="container">
      <div class="col-xs-12">
        <router-link class="pull-right" to="/proveedores">Volver a la lista</router-link>
      </div>
    </div>
    <div class="container">
    <ul class="nav nav-tabs">
      <li role="presentation" class="active">
        <a href="#general" aria-controls="entradas" role="tab" data-toggle="tab">Datos generales</a>
      </li>
      <li role="presentation">
        <a href="#delivery" aria-controls="delivery" role="tab" data-toggle="tab">Delivery y entregas</a>
      </li>
      <li role="presentation">
        <a href="#usuarios" aria-controls="entradas" role="tab" v-if="guardadoBD" data-toggle="tab">Usuarios admin</a>
      </li>
      <li role="presentation">
        <a href="#vinculadas" aria-controls="entradas" role="tab" v-if="guardadoBD" data-toggle="tab">Empresas vinculadas</a>
      </li>
      <li role="presentation">
        <a href="#form-usuario" aria-controls="usuario" role="tab" v-if="guardadoBD" data-toggle="tab">Nuevo Usuario</a>
      </li>
    </ul>
    <div class="box-style line-top">
      <div class="tab-content">
        <div class="tab-pane active in fade" role="tabpanel" id="general">
          <div class="form smart-form">
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="">Razón Social</label>
                    <div class="input">
                      <input type="text" class="form-control" v-model="proveedor.razonSocial">
                      <span class="label label-danger" v-if="(!$v.proveedor.razonSocial.minLength || !$v.proveedor.razonSocial.required) && mostrarErrores">La razon social debe tener por lo menos 3 caracteres</span>
                    </div>
                  </div>
                  <!--
                  <div class="form-group">
                    <label for="">Asignar sucursales</label>
                    <combo-sucursales></combo-sucursales>
                  </div>
                  -->
                  <div class="form-group">
                    <label for="">Dirección</label>
                    <vue-google-autocomplete
                        id="map"
                        ref="direccion"
                        v-if="mapsLoaded"
                        country="ar"
                        classname="form-control"
                        placeholder="Escriba la dirección"
                        v-on:placechanged="getAddressData">
                    </vue-google-autocomplete>
                    <span class="label label-danger" v-if="(!$v.proveedor.direccion.minLength || !$v.proveedor.direccion.required) && mostrarErrores">Debe escribir una dirección</span> 
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-4">
                      <div class="form-group">
                        <label for="">Torre</label>
                        <input type="text" v-model="proveedor.datosGeo.torre" class="form-control">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                      <label for="">Piso</label>
                      <input type="text" v-model="proveedor.datosGeo.piso" class="form-control">
                    </div>
                    <div class="col-xs-12 col-sm-4">
                      <label for="">Departamento</label>
                      <input type="text" v-model="proveedor.datosGeo.departamento" class="form-control">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="">Combos y precios</label>
                    <div class="panel.panel-default">
                      <div class="panel-body">
                        <div class="col-xs-12">
                          <div class="col-xs-12 col-sm-6 col-lg-4">
                            <div class="form-group">
                              <label for="">Combo</label>
                              <select v-model="comboForm.idCombo" class="form-control">
                                <option value="-1">Seleccione un combo</option>
                                <option v-for="combo, idx in combos" :key="combo._id" :value="combo._id">{{combo.nombre}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-xs-12 col-sm-3 col-lg-2">
                            <div class="form-group">
                              <label for="">Precio</label>
                              <input type="text" v-model="comboForm.precio" class="form-control">
                            </div>
                          </div>
                          <div class="col-xs-12 col-sm-3 col-lg-2">
                            <label for=""></label>
                            <button class="btn btn-outline btn-block" @click.prevent="onClickGuardarCombo">Agregar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Combo</th>
                          <th>Precio</th>
                          <th style="text-align: right;">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="precio, idx in proveedor.precios" :key="precio.combo">
                          <td>{{precio.combo.nombre}}</td>
                          <td>{{precio.precio | formatearMoneda}}</td>
                          <td>
                            <ul class="table-actions smart-form">
                              <li>
                                <a @click.prevent="onClickEditPrecio(idx)" class="btn btn-xs btn-ghost" type="button">
                                  <i class="fa fa-actions fa-edit"></i>
                                </a>
                              </li>
                              <li>
                                <a @click.prevent="onClickRemoveCombo(precio.combo._id, idx)" class="btn btn-xs btn-ghost" type="button">
                                  <i class="fa fa-actions fa-remove"></i>
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <span class="label label-danger" v-if="!$v.proveedor.precios.minLength && mostrarErrores">Debe agregar por lo menos un combo</span>
                    <span class="label label-danger" v-if="!$v.proveedor.precios.required && mostrarErrores">Debe agregar por lo menos un combo</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" role="tabpanel fade" id="delivery">
          <form class="form smart-form">
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label for="">Costo del delivery</label>
                      <input type="text" class="form-control" v-model="proveedor.costoDelivery">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label for="">Horarios de entrega</label>
                      <div class="input-group">
                        <input type="text" class="timepicker form-control" value="12:00" ref="timepicker">
                        <span class="input-group-btn">
                          <button class="btn btn-fill" type="button" @click.prevent="onClickAgregarHora">Agregar</button>
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12">
                      <span class="label label-danger" v-if="(!$v.proveedor.horariosEntrega.minLength || !$v.proveedor.horariosEntrega.required) && mostrarErrores">Debe agregar por lo menos un horario de entrega</span> 
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Hora</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="hora, idx in proveedor.horariosEntrega" :key="hora">
                            <td>{{hora}}</td>
                            <td>
                              <ul class="table-actions smart-form">
                                <li>
                                  <a href="" @click.prevent="clickRemoveHorario(idx)" class="btn btn-xs btn-ghost" type="button">
                                    <i class="fa fa-actions fa-remove"></i>
                                  </a>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="tab-pane fade" role="tabpanel fade" id="usuarios" v-if="guardadoBD">
           <form class="form smart-form">
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12">
                  <router-link to="/" class="btn-link pull-right"><span class="semibold">Crear un nuevo usuario</span> <i class="fa fa-angle-right"></i></router-link>
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Email</th>
                        <th>Activo</th>
                        <th class="derecha">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="usuario in usuariosAdmin">
                        <td>{{usuario.displayName}}</td>
                        <td>{{usuario.email}}</td>
                        <td>
                          <i v-if="usuario.activado" class="fa fa-check"></i>
                          <i v-else class="fa fa-times"></i>
                        </td>
                        <td>
                          <ul class="table-actions smart-form">
                            <li v-if="usuario.activado">
                              <a class="btn btn-xs btn-ghost" type="button" title="Desactivar" @click="onClickCambiarActivo(usuario._id, false)">
                                <i class="fa fa-actions fa-user-times"></i>
                              </a>
                            </li>
                            <li v-else>
                              <a class="btn btn-xs btn-ghost" type="button" title="Activar" @click="onClickCambiarActivo(usuario._id, true)">
                                <i class="fa fa-actions fa-user-plus"></i>
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
           </form>
        </div>
        <div class="tab-pane fade" role="tabpanel fade" id="vinculadas" v-if="guardadoBD">
          <div class="smart-form">
            <div class="box-body">
              <div class="row">
                <template v-if="sucursalesVinculadas.length > 0">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Combo asignado</th>
                        <th>Horario de entrega</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="sucursal in sucursalesVinculadas">
                        <td>{{sucursal.empresa.razonSocial}}-{{sucursal.denominacion}}</td>
                        <td>{{getNombreCombo(sucursal.comboSubsidiado)}}</td>
                        <td>{{sucursal.horaAsignada}}</td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <template v-else>
                  <h1 class="text-center">El proveedor no tiene empresas asignadas</h1>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" role="tabpanel" id="form-usuario" v-if="guardadoBD">
          <div class="box-style line-top">
							<form class="form smart-form">
							
								<!-- Agregar usuarios -->
								<div class="box-header">
									<h2>NUEVO USUARIO</h2>
								</div>
								<div class="box-body">
									<div class="row">
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Nombre</label>
                        <input type="text" v-model="usuario.firstName" class="form-control">
                        <span class="label label-danger" v-if="!$v.usuario.firstName.required && mostrarErroresUsuario">Campo requerido</span>
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Apellido</label>
                        <input type="text" v-model="usuario.lastName" class="form-control">
                        <span class="label label-danger" v-if="!$v.usuario.lastName.required && mostrarErroresUsuario">Campo requerido</span>
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>E-mail</label>
                        <input type="mail" v-model="usuario.email" class="form-control">
                        <span class="label label-danger" v-if="(!$v.usuario.email.required || !$v.usuario.email.email ) && mostrarErroresUsuario">Formato no válido</span>
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Celular</label>
												<input type="text" v-model="usuario.telefonoCelular" class="form-control">
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="row">
												<div class="col-xs-12 col-sm-6 col-md-8 col-lg-8">
													<div class="form-group">
														<label>Teléfono fijo</label>
														<input type="text" v-model="usuario.telefonoFijo" class="form-control" placeholder="De su área de trabajo">
													</div>
												</div>
												<div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
													<div class="form-group">
														<label>Interno</label>
														<input type="text" v-model="usuario.interno" class="form-control">
													</div>
												</div>
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Área</label>
												<div class="select">
													<select>
														<option value="">Elija...</option>
														<option value="">Atención al Cliente</option>
														<option value="">Administración</option>
														<option value="">Contaduría</option>
														<option value="">Área comercial</option>
														<option value="">Recepción</option>
													</select>
													<i class="fa fa fa-angle-down"></i>
												</div>
											</div>
										</div>
									</div>
								</div><!-- fin Datos personales -->

								<div class="box-header subline-top">
									<h2>DATOS DE ACCESO</h2>
								</div>
								<div class="box-body">
									<div class="row">
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Usuario</label>
                        <input type="text" v-model="usuario.username" class="form-control">
                        <span class="label label-danger" v-if="!$v.usuario.username.required && mostrarErroresUsuario">Campo requerido</span>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Contraseña</label>
                        <input type="password" v-model="usuario.password" class="form-control">
                        <span class="label label-danger" v-if="!$v.usuario.password.required && mostrarErroresUsuario">Campo requerido</span>
											</div>
										</div>
										<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Repetir contraseña</label>
                        <input type="password" v-model="usuario.repeatPassword" class="form-control">
                        <span class="label label-danger" v-if="(!$v.usuario.repeatPassword.sameAsPassword) && mostrarErroresUsuario">No coincide con el password dado</span>
											</div>
										</div>
									</div>
									<div class="form-action text-center">
										<button type="submit" class="btn btn-fill" @click.prevent="onClickGuardarUsuario">GUARDAR</button>
									</div>
								</div>
							</form>
						</div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="text-center center-block" style="padding-top: 1em;">
          <button class="btn btn-fill" @click="onClickGuardarProveedor">Guardar Proveedor</button>
        </div>
      </div>
    </div>
    
  </div>
  </section>
</template>
<script>
  import 'flatpickr/dist/flatpickr.css'
  import 'flatpickr/dist/themes/material_green.css'
  import flatpickr from 'flatpickr'
  import {minLength, required, email, sameAs} from 'vuelidate/lib/validators'
  import _ from 'lodash'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import 'sweetalert2/dist/sweetalert2.css'
  import swal from 'sweetalert2'
  export default {
    components: {
      'vue-google-autocomplete': VueGoogleAutocomplete
    },
    props: ['maps-loaded'],
    filters: {
      formatearMoneda (value) {
        return '$ ' + parseFloat(value).toFixed(2)
      }
    },
    data () {
      return {
        guardadoBD: false,
        idxEdicionCombo: -1,
        mostrarErrores: false,
        mostrarErroresUsuario: true,
        proveedor: {
          _id: undefined,
          razonSocial: '',
          direccion: '',
          datosGeo: {
            direccion: '',
            direccionFormateada: '',
            latitud: 0,
            longitud: 0,
            torre: '',
            piso: '',
            departamento: ''
          },
          costoDelivery: 0,
          precios: [],
          horariosEntrega: []
        },
        comboForm: {
          idx: -1,
          idCombo: '-1',
          precio: 0
        },
        combos: [],
        usuariosAdmin: [],
        usuario: {
          firstName: '',
          lastName: '',
          email: '',
          telefonoFijo: '',
          telefonoCelular: '',
          interno: '',
          area: '',
          username: '',
          password: '',
          repeatPassword: ''
        },
        sucursalesVinculadas: []
      }
    },
    validations: {
      proveedor: {
        razonSocial: {
          required,
          minLength: minLength(3)
        },
        direccion: {
          required,
          minLength: minLength(3)
        },
        precios: {
          required,
          minLength: minLength(1)
        },
        horariosEntrega: {
          required,
          minLength: minLength(1)
        }
      },
      usuario: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        email: {
          email,
          required
        },
        password: {
          required
        },
        username: {
          required
        },
        repeatPassword: {
          sameAsPassword: sameAs('password')
        }
      }
    },
    methods: {
      cambiarEstadoActivo (id, valor) {
        const me = this
        me.$http.post('/api/admin/cambiarestadoactivo', {
          valor: valor,
          id: id
        }).then(({body}) => {
          let usuarioCambiado = me.usuariosAdmin.find((usuario) => {
            return usuario._id === id
          })
          usuarioCambiado.activado = valor
        }, (err) => {
          console.error(err)
        })
      },
      clearFormCombo () {
        const me = this
        me.comboForm = {
          precio: 0,
          idCombo: '-1'
        }
        me.idxEdicionCombo = -1
      },
      clickRemoveHorario (idx) {
        const me = this
        me.proveedor.horariosEntrega.splice(idx, 1)
      },
      getAddressData (e, place) {
        const me = this
        me.proveedor.datosGeo = {
          latlong: [e.latitude, e.longitude],
          direccion: place.name,
          direccionFormateada: place.formatted_address,
          torre: me.proveedor.datosGeo.torre,
          piso: me.proveedor.datosGeo.piso,
          departamento: me.proveedor.datosGeo.departamento
        }
        me.proveedor.direccion = place.formatted_address
      },
      getNombreCombo (idCombo) {
        const me = this
        let nombre = ''
        let existeCombo = me.combos.find((combo) => {
          return combo._id === idCombo
        })
        if (existeCombo) {
          nombre = existeCombo.nombre
        }
        return nombre
      },
      onClickAgregarHora (e) {
        const me = this
        let hora = me.$refs.timepicker.value
        if (hora.trim() === '') {
          me.$emit('mostrar-notificacion', 'La hora está vacía')
          return false
        }
        let existeHorario = me.proveedor.horariosEntrega.find((horario) => {
          return horario === hora
        })
        if (existeHorario) {
          me.$emit('mostrar-notificacion', 'El horario ya está agregado', 'error')
          return false
        }
        me.proveedor.horariosEntrega.push(hora)
      },
      onClickCambiarActivo (id, valor) {
        const me = this
        swal({
          title: 'Confirme operación',
          text: '¿Desea cambiar el estado del usuario seleccionado?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si',
          cancelButtonText: 'No, dejar sin efecto'
        }).then(() => {
          me.cambiarEstadoActivo(id, valor)
        }, (dismiss) => {
          return false
        })
      },
      onClickGuardarCombo () {
        const me = this
        if (me.comboForm.idCombo === '-1') {
          me.$emit('mostrar-notificacion', 'Debe seleccionar un combo', 'error')
          return false
        }
        if (me.comboForm.precio < 1) {
          me.$emit('mostrar-notificacion', 'Debe poner un precio', 'error')
          return false
        }
        let comboSeleccionado = me.combos.find((combo) => {
          return combo._id === me.comboForm.idCombo
        })
        let combo = Object.assign({}, comboSeleccionado)
        if (me.idxEdicionCombo === -1) {
          let existeCombo = me.proveedor.precios.find((precio) => {
            return precio.combo._id === me.comboForm.idCombo
          })
          if (existeCombo) {
            me.$emit('mostrar-notificacion', 'El combo ya existe para el proveedor', 'error')
            return false
          }
          me.proveedor.precios.push({
            combo: combo,
            precio: parseFloat(me.comboForm.precio)
          })
        } else {
          /* Refactorizar en algun momento */
          if (me.proveedor.precios[me.idxEdicionCombo].combo._id === combo._id) {
            me.proveedor.precios.splice(me.idxEdicionCombo, 1, {
              combo: combo,
              precio: parseFloat(me.comboForm.precio)
            })
          } else {
            let existeCombo = me.proveedor.precios.find((precio, idx) => {
              return precio.combo._id === combo._id && idx !== me.idxEdicionCombo
            })
            if (existeCombo) {
              me.$emit('mostrar-notificacion', 'El combo ya está asignado', 'error')
              return false
            } else {
              me.proveedor.precios.splice(me.idxEdicionCombo, 1, {
                combo: combo,
                precio: parseFloat(me.comboForm.precio)
              })
            }
          }
        }
        me.clearFormCombo()
      },
      onClickEditPrecio (idx) {
        const me = this
        me.idxEdicionCombo = idx
        me.comboForm.idCombo = me.proveedor.precios[idx].combo._id
        me.comboForm.precio = me.proveedor.precios[idx].precio
      },
      onClickGuardarProveedor () {
        const me = this
        me.mostrarErrores = false
        if (me.$v.proveedor.$invalid) {
          me.mostrarErrores = true
          return false
        }
        me.$http.post('/api/admin/proveedores', {
          proveedor: me.proveedor
        }).then(({body}) => {
          console.log('guardar', body)
          me.$emit('mostrar-notificacion', 'El proveedor se guardó correctamente', 'success')
          me.$router.push({
            path: '/proveedores'
          })
        }, (err) => {
          console.error(err)
        })
      },
      onClickGuardarUsuario () {
        const me = this
        if (me.$v.usuario.$invalid) {
          me.mostrarErroresUsuario = true
          return false
        }
        let usuario = me.usuario
        usuario.proveedorAsociado = me.proveedor._id
        me.$http.post('/api/users/adminrestaurante', usuario).then(({body}) => {
          me.$emit('mostrar-notificacion', 'El usuario se creó correctamente', 'success')
          me.$router.push({
            path: '/proveedores'
          })
        }, (err) => {
          console.error(err)
        })
      },
      onClickRemoveCombo (idCombo, idx) {
        const me = this
        if (!me.guardadoBD) {
          me.proveedor.precios.splice(idx, 1)
          return false
        }
        me.$http.post('/api/admin/puedeborrarcombo', {
          idProveedor: me.proveedor._id,
          idCombo: idCombo
        }).then((response) => {
          const estaAsignado = response.body.estaAsignado
          if (estaAsignado) {
            console.log('esta asignado')
            me.$emit('mostrar-notificacion', 'El combo está asignado a un cliente', 'error')
            return false
          } else {
            let precio = me.proveedor.precios.find((precio) => {
              return precio.combo._id === idCombo
            })
            let idx = me.proveedor.precios.indexOf(precio)
            if (idx > -1) {
              me.proveedor.precios.splice(idx, 1)
            }
          }
        }, (err) => {
          console.error(err)
        })
      }
    },
    mounted () {
      const me = this
      flatpickr(me.$refs.timepicker, {
        enableTime: true,
        noCalendar: true,
        enableSeconds: false, // disabled by default
        time_24hr: true, // AM/PM time picker is used by default
        // default format
        dateFormat: 'H:i',
        // initial values for time. don't use these to preload a date
        defaultHour: 12,
        defaultMinute: 0
      })
      me.$http.get('/api/admin/initformproveedor', {
        params: {
          idProveedor: me.$route.params.id || null
        }
      }).then(({body}) => {
        me.combos = _.sortBy(body.combos, 'nombre')
        me.proveedor = Object.assign(me.proveedor, body.proveedor)
        me.sucursalesVinculadas = body.sucursalesVinculadas
        me.usuariosAdmin = body.usuarios
        me.guardadoBD = body.guardadoBD
        me.$refs.direccion.update(me.proveedor.direccion)
      }, (err) => {
        console.log('err', err)
      })
    }
  }
</script>
<style scoped>
  .timepicker.form-control[disabled], .timepicker.form-control[readonly], fieldset[disabled] .timepicker.form-control {
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// Form.vue?ffab361e